import { ArrowUpRight } from "lucide-react";
import { PanelCard } from "@/admin/components/PanelCard";

export function StatCard({ title, value, delta, icon: Icon, tone = "blue" }) {
  const accent =
    tone === "navy"
      ? "bg-[#0b1221] text-white shadow-[0_18px_30px_rgba(11,18,33,0.18)]"
      : "bg-[#edf3ff] text-[#0033ff]";

  return (
    <PanelCard className="p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-[#6c7c98]">{title}</p>
          <p className="mt-3 font-display text-3xl font-extrabold tracking-tight text-[#0b1221]">
            {value}
          </p>
          <p className="mt-3 inline-flex items-center gap-1 rounded-full bg-[#eef6ff] px-3 py-1 text-xs font-semibold text-[#0b5bd3]">
            <ArrowUpRight className="h-3.5 w-3.5" />
            {delta}
          </p>
        </div>
        <span className={["flex h-12 w-12 items-center justify-center rounded-2xl", accent].join(" ")}>
          <Icon className="h-5 w-5" />
        </span>
      </div>
    </PanelCard>
  );
}